import { lazy } from 'react';
import { getHomeRouteForLoggedInUser } from '@utils';
import ReportesRoutes from './ReportesRoutes';

// ** Document title
const TemplateTitle = 'Seia';

const DefaultRoute = getHomeRouteForLoggedInUser;

// ** Merge Routes
const Routes = [
	{
		path: '/login',
		component: lazy(() => import('../../views/Auth/Login')),
		layout: 'BlankLayout',
		meta: {
			authRoute: true
		}
	},
	{
		path: '/forgot-password',
		component: lazy(() => import('../../views/Auth/ForgotPassword')),
		layout: 'BlankLayout',
		meta: {
			authRoute: true
		}
	},
	{
		path: '/reset-password/:token',
		component: lazy(() => import('../../views/Auth/ResetPassword')),
		layout: 'BlankLayout',
		meta: {
			authRoute: true
		}
	},
	{
		path: '/set-password/:token',
		component: lazy(() => import('../../views/Auth/SetPassword')),
		layout: 'BlankLayout',
		meta: {
			authRoute: true
		}
	},
	{
		path: '/error',
		component: lazy(() => import('../../views/Error')),
		layout: 'BlankLayout'
	},
	{
		path: '/users/create',
		component: lazy(() => import('../../views/Users/create')),
		meta: {
			navLink: '/users/create',
			resource: 'usuarios',
			action: 'create'
		}
	},
	{
		path: '/users/view/:id',
		component: lazy(() => import('../../views/Users/details')),
		meta: {
			navLink: '/users/view/:id',
			resource: 'usuarios',
			action: 'show'
		}
	},
	{
		path: '/users/edit/:id',
		component: lazy(() => import('../../views/Users/edit')),
		meta: {
			navLink: '/users/edit/:id',
			resource: 'usuarios',
			action: 'edit'
		}
	},
	{
		path: '/users',
		component: lazy(() => import('../../views/Users')),
		meta: {
			navLink: '/users',
			resource: 'usuarios',
			action: 'show'
		}
	},
	{
		path: '/roles',
		component: lazy(() => import('../../views/RolesPermissions')),
		exact: true,
		meta: {
			navLink: '/roles',
			resource: 'roles',
			action: 'show'
		}
	},
	{
		path: '/roles/create',
		component: lazy(() => import('../../views/RolesPermissions/create')),
		meta: {
			navLink: '/roles/create',
			resource: 'roles',
			action: 'show'
		}
	},
	{
		path: '/roles/edit/:id',
		component: lazy(() => import('../../views/RolesPermissions/edit')),
		meta: {
			navLink: '/roles/edit',
			resource: 'roles',
			action: 'show'
		}
	},
	{
		path: '/roles/view/:id',
		component: lazy(() => import('../../views/RolesPermissions/details')),
		meta: {
			navLink: '/roles/view/:id',
			resource: 'roles',
			action: 'show'
		}
	},
	{
		path: '/fichas_activas/view/:id',
		component: lazy(() => import('../../views/FichasActivas/details')),
		meta: {
			navLink: '/fichas_activas/view/:id',
			resource: 'fichas_activas',
			action: 'show'
		},
		className: 'layout-overflow-auto'
	},
	{
		path: '/fichas_activas/add/:ficha_id/caida',
		component: lazy(() => import('../../views/FichasActivas/add_caida')),
		meta: {
			navLink: '/fichas_activas/add/:id/caida',
			resource: 'fichas_activas',
			action: 'show'
		},
		className: 'layout-overflow-auto'
	},
	{
		path: '/fichas_activas/create/:step?/:sub_step?',
		component: lazy(() => import('../../views/FichasActivas/create')),
		meta: {
			navLink: '/fichas_activas/create/:step?/:sub_step?',
			resource: 'fichas_activas',
			action: 'show'
		},
		className: 'layout-overflow-auto'
	},
	{
		path: '/fichas_activas/create',
		component: lazy(() => import('../../views/FichasActivas/create')),
		meta: {
			navLink: '/fichas_activas/create',
			resource: 'fichas_activas',
			action: 'show'
		},
		className: 'layout-overflow-auto'
	},
	{
		path: '/fichas_activas/confrontar',
		component: lazy(() => import('../../views/FichasActivas/ConfrontarHuella')),
		meta: {
			navLink: '/fichas_activas/create',
			resource: 'fichas_activas',
			action: 'show',
			contentCard: true
		}
	},
	{
		path: '/fichas_activas',
		component: lazy(() => import('../../views/FichasActivas')),
		exact: true,
		meta: {
			navLink: '/fichas_activas',
			resource: 'fichas_activas',
			action: 'show'
		},
		className: 'layout-overflow-auto'
	},
	{
		path: '/fichas_canceladas/confrontar',
		component: lazy(() => import('../../views/FichasCanceladas/confrontar')),
		meta: {
			navLink: '/fichas_canceladas/create',
			resource: 'fichas_canceladas',
			action: 'show',
			contentCard: true
		}
	},
	{
		path: '/fichas_canceladas',
		component: lazy(() => import('../../views/FichasCanceladas')),
		exact: true,
		meta: {
			navLink: '/fichas_canceladas',
			resource: 'fichas_canceladas',
			action: 'show'
		}
	},
	{
		path: '/fichas_canceladas/view/:id',
		component: lazy(() => import('../../views/FichasCanceladas/details')),
		meta: {
			navLink: '/fichas_canceladas/view/:id',
			resource: 'fichas_canceladas',
			action: 'show'
		},
		className: 'layout-overflow-auto'
	},
	{
		path: '/fichas_eliminadas',
		component: lazy(() => import('../../views/FichasEliminadas')),
		exact: true,
		meta: {
			navLink: '/fichas_eliminadas',
			resource: 'fichas_eliminadas',
			action: 'show'
		}
	},
	{
		path: '/solicitudes_pendientes',
		component: lazy(() => import('../../views/SolicitudesPendientes')),
		exact: true,
		meta: {
			navLink: '/solicitudes_pendientes',
			resource: 'solicitudes',
			action: 'show'
		}
	},
	{
		path: '/solicitudes_autorizar',
		component: lazy(() => import('../../views/SolicitudesPorAutorizar')),
		exact: true,
		meta: {
			navLink: '/solicitudes_autorizar',
			resource: 'solicitudes',
			action: 'show'
		}
	},
	{
		path: '/fichas/:ficha_id/caidas/view/:id',
		component: lazy(() => import('../../views/Caidas/details')),
		meta: {
			navLink: '/fichas/:ficha_id/caidas/view/:id',
			resource: 'fichas_activas',
			action: 'show'
		},
		className: 'layout-overflow-auto'
	},
	{
		path: '/confrontar_resultados',
		component: lazy(() => import('../../views/FichasActivas/resultsList')),
		meta: {
			navLink: '/confrontar_resultados',
			resource: 'roles',
			action: 'show'
		},
		className: 'layout-overflow-auto'
	},
	{
		path: '/consulta_fichas/:id/ficha/view/:ficha_id',
		component: lazy(() => import('../../views/ConsultaFichas/details')),
		meta: {
			navLink: '/consulta_fichas/:id/ficha/view/:ficha_id',
			resource: 'roles',
			action: 'show'
		},
		className: 'layout-overflow-auto'
	},
	{
		path: '/consulta_fichas/:id',
		component: lazy(() => import('../../views/ConsultaFichas/resultsList')),
		meta: {
			navLink: '/consulta_fichas/:id',
			resource: 'roles',
			action: 'show'
		}
	},
	{
		path: '/consulta_fichas',
		component: lazy(() => import('../../views/ConsultaFichas')),
		meta: {
			navLink: '/consulta_fichas',
			resource: 'consultar_fichas',
			action: 'show'
		},
		className: 'layout-overflow-auto'
	},
	{
		path: '/consulta_familiar/ficha/view/:ficha_id',
		component: lazy(() => import('../../views/ConsultaFamiliar/details')),
		meta: {
			navLink: '/consulta_familiar/ficha/view/:ficha_id',
			resource: 'roles',
			action: 'show'
		},
		className: 'layout-overflow-auto'
	},
	{
		path: '/consulta_familiar',
		component: lazy(() => import('../../views/ConsultaFamiliar')),
		meta: {
			navLink: '/consulta_familiar',
			resource: 'roles',
			action: 'show'
		},
		className: 'layout-overflow-auto'
	},
	{
		path: '/catalogos',
		component: lazy(() => import('../../views/Catalogos')),
		meta: {
			navLink: '/catalogos',
			resource: 'catalogos',
			action: 'show',
			contentCard: true
		}
	},
	{
		path: '/constancias/resultados',
		component: lazy(() =>
			import('../../views/Constancias/NuevaConstancia/Modals/Resultados')
		),
		meta: {
			navLink: '/constancias/resultados',
			resource: 'constancias',
			action: 'show'
		},
		className: 'layout-overflow-auto'
	},
	{
		path: '/constancias/pdf',
		component: lazy(() => import('../../views/Constancias/preview_pdf')),
		meta: {
			navLink: '/constancias/pdf',
			resource: 'constancias',
			action: 'show'
		},
		className: 'layout-overflow-auto'
	},
	{
		path: '/constancias/create/:step?/:sub_step?',
		component: lazy(() => import('../../views/Constancias/create')),
		meta: {
			navLink: '/constancias/create/:step?/:sub_step?',
			resource: 'constancias',
			action: 'show'
		},
		className: 'layout-overflow-auto'
	},
	{
		path: '/constancias/create',
		component: lazy(() => import('../../views/Constancias/create')),
		meta: {
			navLink: '/constancias/create',
			resource: 'constancias',
			action: 'show'
		},
		className: 'layout-overflow-auto'
	},
	{
		path: '/constancias/view/:id',
		component: lazy(() => import('../../views/Constancias/details')),
		meta: {
			navLink: '/constancias/view/:id',
			resource: 'constancias',
			action: 'show'
		},
		className: 'layout-overflow-auto'
	},
	{
		path: '/configuracion',
		component: lazy(() => import('../../views/Configuracion')),
		meta: {
			navLink: '/configuracion',
			resource: 'configuracion',
			action: 'cargar'
		}
	},
	{
		path: '/change_password',
		component: lazy(() => import('../../views/CambiarPass')),
		meta: {
			navLink: '/change_password',
			resource: 'roles',
			action: 'show'
		}
	},
	{
		path: '/constancias',
		component: lazy(() => import('../../views/Constancias')),
		meta: {
			navLink: '/constancias',
			resource: ['constancias', 'en_linea'],
			action: 'show',
			someRole: true
		},
		className: 'layout-overflow-auto'
	},
	{
		path: '/historial_cambios/ficha_signalectica',
		component: lazy(() => import('../../views/Reportes/fichaSignalectica')),
		meta: {
			navLink: '/reportes',
			resource: 'reportes',
			action: 'show'
		}
	},
	{
		path: '/historial_cambios/:id',
		component: lazy(() => import('../../views/Reportes/historialCambios')),
		meta: {
			navLink: '/reportes',
			resource: 'reportes',
			action: 'show'
		}
	},
	...ReportesRoutes,
	{
		path: '/modulos/create',
		component: lazy(() => import('../../views/Modulos/create')),
		meta: {
			navLink: '/modulos/create',
			resource: 'modulos',
			action: 'show'
		},
		className: 'layout-overflow-auto'
	},
	{
		path: '/modulos/edit/:id',
		component: lazy(() => import('../../views/Modulos/edit')),
		meta: {
			navLink: '/modulos/edit',
			resource: 'modulos',
			action: 'show'
		}
	},
	{
		path: '/modulos/view/:id',
		component: lazy(() => import('../../views/Modulos/details')),
		meta: {
			navLink: '/modulos/view/:id',
			resource: 'modulos',
			action: 'show'
		}
	},
	{
		path: '/modulos',
		component: lazy(() => import('../../views/Modulos')),
		meta: {
			navLink: '/modulos',
			resource: 'modulos',
			action: 'show'
		}
	}
];

export { DefaultRoute, TemplateTitle, Routes };
